module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/packages/yofoui/customized/preViewMedia/assets/fullBackBtn.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/customized/preViewMedia/assets/fullBackBtn.png
// module id = 1814
// module chunks = 418